/**
 * task-approvals-store — hook frontend pra GET /api/v1/task-approvals/me/pending
 *
 * FASE 4 / M3 (auditoria 2026-05-21): backend tinha endpoint sem consumer
 * frontend. Quando admin dismissava a notification inline, não havia outra
 * forma de ver pendências. Este hook + PendingApprovalsWidget destravam a UX.
 */

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { api, hasToken } from './api';

export interface TaskApprovalPending {
  id: string;
  taskId: string;
  solicitanteUserId: string;
  solicitanteNome: string | null;
  criadoEmIso: string;
  task: {
    titulo: string;
    cardId: string | null;
    workflowSlug: string | null;
    startAtIso: string | null;
  };
}

const KEYS = {
  pending: ['v1', 'task-approvals', 'me', 'pending'] as const,
};

export function usePendingApprovals() {
  return useQuery({
    queryKey: KEYS.pending,
    queryFn: () =>
      api.get<TaskApprovalPending[]>('/api/v1/task-approvals/me/pending'),
    enabled: hasToken(),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}

/** Helper pra invalidar a query (chamado após decidir aprovação inline). */
export function useInvalidatePendingApprovals() {
  const qc = useQueryClient();
  return useCallback(() => {
    void qc.invalidateQueries({ queryKey: KEYS.pending });
  }, [qc]);
}
